import consola from 'consola'
import { useLogger, createSharedComposable } from '#imports'

export const useCoreLogger = createSharedComposable(() => {
    return useLogger().withTag('@spilnu/core')
})
